import { GridApi } from '@ag-grid-community/core';
import { compressToEncodedURIComponent } from 'lz-string';

/**
 * Handles loading a saved view by updating the URL with the saved state and reloading the page
 */
export function handleViewLoad(viewState: Record<string, any>) {
  // Navigate to a new URL with the saved state
  // This will trigger a page reload with the saved state applied
  if (viewState.state || viewState.search) {
    const searchParams = new URLSearchParams();

    if (viewState.state) {
      const compressed = compressToEncodedURIComponent(JSON.stringify(viewState.state));
      searchParams.set('state', compressed);
    }

    if (viewState.search) {
      searchParams.set('search', encodeURIComponent(viewState.search));
    }

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({}, '', newUrl);
    window.location.reload();
  } else {
    console.error('No state or search found in viewState');
  }
}

/**
 * Gets the current view state including grid state and search query
 */
export function getCurrentViewState<T = any>(
  gridApi: React.MutableRefObject<GridApi<T> | undefined>,
  getSearch: () => string
): Record<string, any> {
  const gridState = gridApi.current?.getState();
  const currentSearch = getSearch();
  return {
    state: gridState,
    search: currentSearch
  };
}
